import { warning, confirmation } from '@/utils/alert'

const prepareShow = agendas => {
  agendas.countrules = agendas.countrules.length
  return agendas
}

export default {
  doDeleteNextSetp (agenda) {
    this.$resource.post('' + agenda.id + '/verify')
      .then(({data}) => {
        if (data.active) {
          warning(data.msg)
        }
        if (!data.active) {
          warning(data.msg)
          this.doDelete(agenda, data.msg)
        }
      })
      .catch(({data, meta}) => {
        this.loginFail = true
      })
  },
  doDelete (item, msg) {
    this.currentEntity = item
    const message = {
      label: 'Excluir',
      title: 'Atenção',
      message: msg,
      cancel: 'Cancelar'
    }

    confirmation(confirm => {
      if (!confirm) {
        return
      }

      this.doDeleteWithoutConfirmation(item)
    }, message.message, message.title, message.label, message.cancel)
  },
  doDeleteWithoutConfirmation (entity) {
    this.currentEntity = entity
    if (!this.beforeDelete(entity)) {

    }

    this.$resource.delete(entity.id)
      .then(({data}) => {
        this.afterDelete(entity, data)
      })
  },
  prepareShow,
  onShow () {
    this.show = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/index/resources/methods.js